import axios from 'axios';

import {
  GENERATED_REPORT_DOWNLOAD,
  GENERATED_REPORTS
} from 'RestAPIs/endpoints';

export enum StatusEnum {
  'DONE' = 'DONE',
  'FAILED' = 'FAILED',
  'STARTED' = 'STARTED',
  'TIMEOUT' = 'TIMEOUT'
}

export type GeneratedReport = {
  fileId: number;
  reportName: string;
  status: StatusEnum;
  inserted: string;
  generated: string;
  message: string | null;
  filename: string | null;
  parameters: Record<string, any>;
};

export const getGeneratedReports = () =>
  axios.get<GeneratedReport[]>(GENERATED_REPORTS);

export const getDownloadUrl = (reportId: number) =>
  axios.get<string>(GENERATED_REPORT_DOWNLOAD, {
    pathParams: {
      reportId
    }
  });
